
const UUID = require('uuid-js');

function getBundle(patientId, observations, recommendationId, sessionId, alternateNames, serviceIds, fhirOrg = null, proxy = {}){
  const enrichedObservations = []
  const serviceRequestUri = `urn:uuid:${UUID.create().toString()}`
  const consentUri = `urn:uuid:${UUID.create().toString()}`

  if(!fhirOrg){
    fhirOrg = {
      organization: "MI211",
      authority: "mi211.org",
      uri: "https://mi211.org/homevisiting",
      code: "home-visiting",
      display: "Home Visiting"
    }
  }

  observations.forEach( obs => {
    obs.subject = { reference: `Patient/${patientId}` }
    obs.status = 'final'
    obs.basedOn = [
      {
        reference: serviceRequestUri,
        type: 'ServiceRequest'
      },
    ]
    enrichedObservations.push({
      request: {
        method: 'POST',
        url: 'Observation',
    },
    fullUrl: `urn:uuid:${UUID.create().toString()}`,
    resource: obs
    })
  })

  const coding = []
  alternateNames.forEach( alt => {
    coding.push({
      system: 'https://211taxonomy.org/',
      code: alt,
      display: alt,
    })
  })

  const serviceReference = []
  serviceIds.forEach( id => {
    serviceReference.push({
      identifier: {value: `${id}` },
      type: 'HealthcareService',
    })
  })
  
  const bundle = {
    resourceType: 'Bundle',
    type: 'transaction',
    entry: [
        {
            request: {
                method: 'POST',
                url: 'Consent',
            },
            fullUrl: consentUri,
            resource: {
              resourceType: "Consent",
              status: "active",
              scope: {
                coding: [
                  {
                    system: "http://terminology.hl7.org/CodeSystem/consentscope",
                    code: "patient-privacy"
                  }
                ]
              },
              category: [
                 {
                    coding: [
                       {
                          system: "http://loinc.org",
                          code: "59284-0"
                       }
                    ]
                 }
              ],
              patient: {
                 reference: `Patient/${patientId}`
              },
              dateTime: new Date().toISOString(),
              organization: [
                 {
                    reference: `Organization/${fhirOrg.organization}`
                 }
              ],
              policy: [
                 {
                      authority: fhirOrg.authority,
                      uri: fhirOrg.uri
                 }
              ],
              provision: {
                 type: "deny",
                 provision: [
                    {
                       type: "permit",
                       period: {
                          start: "1964-01-01",
                          end: "2019-01-01"
                       }
                    }
                 ]
              }
           }
            },
        ...enrichedObservations,
        {
            request: {
                method: 'POST',
                url: 'ServiceRequest',
            },
            fullUrl: serviceRequestUri,
            resource: {
                resourceType: 'ServiceRequest',
                identifier: [{
                    use: 'official',
                    type: {
                      text : "recommendation_id",
                    },
                    system: fhirOrg.authority, //This will tell the hub which id this belongs to
                    value: recommendationId,
                }],
                requisition: {
                    use: 'official',
                    system: `https://${fhirOrg.authority}`,
                    value: sessionId,
                },
                status: 'active',
                intent: 'original-order',
                category: [
                  {
                    coding: [
                      {
                        system: `http://${fhirOrg.authority}`,
                        code: fhirOrg.code,
                        display: fhirOrg.display
                      }
                    ]
                  }
                ],
                code: {
                    coding: coding,
                },
                requester: {
                    reference: `Patient/${patientId}`,
                },
                subject: {
                    reference: `Patient/${patientId}`
                },
                supportingInfo: [
                    {
                      reference: consentUri,
                      type: 'Consent'
                    },
                ],
                performer: serviceReference
            }
        }
    ]
  }

  const serviceRequest = bundle.entry.find( entry => entry.resource.resourceType === 'ServiceRequest')
  console.log("serviceRequest:found", serviceRequest)
  console.log("proxy", proxy)
  if(Object.keys(proxy).length > 0){
    const resource = serviceRequest.resource
    resource.extension = [
      {
        url: "http://hl7.org/fhir/StructureDefinition/referringName",
        valueString: proxy.fullName
      },
      {
        url: "http://hl7.org/fhir/StructureDefinition/referringEmail",
        valueString: proxy.email
      },
      {
        url: "http://hl7.org/fhir/StructureDefinition/referringTitle",
        valueString: proxy.title
      },
      {
        url: "http://hl7.org/fhir/StructureDefinition/referringPhone",
        valueString: proxy.phone
      },
      {
        url: "http://hl7.org/fhir/StructureDefinition/referringFamilyRelationship",
        valueString: proxy.relationship
      },
      {
        url: "http://hl7.org/fhir/StructureDefinition/referringConsent",
        valueBoolean: proxy.consent
      },
      {
        url: "http://hl7.org/fhir/StructureDefinition/referringOrganization",
        valueString: proxy.organization
      }
    ]
  }

  return bundle
}
function getObservations (userData){
    const {household, children} = userData
    const observations = []
      observations.push(getObservation('99951-6', 'Zip Code', household.zipcode, 'valueString' ))
      observations.push(getObservation('97071-5', 'Is someone in the household currently pregnant', household.anyonePregnant === 'Yes' ? "true" : "false", 'valueBoolean'))
      if(household.anyonePregnant === 'Yes') {
        observations.push(getObservation('63962-5', 'Pregnancy Type', household.pregnancyType, 'valueString')) 
      }
      if(household.dueDate){
          observations.push(getObservation('11778-8', 'Due Date', household.dueDate, 'valueDateTime'))
      }
      observations.push(getObservation('95369-5', 'Affiliated with a tribe', household.tribalAffiliation === 'Yes' ? "true" : "false", 'valueBoolean' ))
      observations.push(getObservation('MI211-27268-1', 'Number of children under the age of 6 living in household', children.childNameDob.length.toString(), 'valueInteger' ))
      children.childNameDob.forEach( child => {
          observations.push(getObservation('MI211-45392-8', 'Child Name', child.childName, 'valueString' ))
          observations.push(getObservation('MI211-21112-8', 'Date of Birth', child.childDob, 'valueDateTime', `childName=${child.childName}`))
      })
  
      return observations
  }
  
  function getObservation (code, display, value, valueType, note){
    if(valueType === "valueBoolean" && value === "true")  value = true
    if(valueType === "valueBoolean" && value === "false")  value = false
    if(valueType === "valueInteger" )  value = parseInt(value)
    const localTime = new Date(new Date().toString().split('GMT')[0]+' UTC').toISOString();
    const obeservation = {
          resourceType: "Observation",
          status: "preliminary",
          code: {
            coding: [
              {
                system: "https://loinc.org",
                code,
                display
              }
            ]
          },
          effectiveDateTime: localTime,
          [valueType]: value
        }

      if(note) obeservation.note = [{ text: note }]

      return obeservation
    }

    function getPatient (userData, org = "MI211"){
      const { contact:  { name, address, phone, email } } = userData
      const addressLines = []
        addressLines.push(address.address1)
        if(address.address2) addressLines.push(address.address2)
    
        const teleCom = []
        if(phone.mobile) teleCom.push({
          system: "phone",
          value: phone.mobile,
          use: "mobile"
        })
        if(phone.home) teleCom.push({
          system: "phone",
          value: phone.home,
          use: "home"
        })
        teleCom.push({
          system: "email",
          value: email,
          use: "home"
        })
    
        const patient = {
            resourceType: "Patient",
            active: true,
            name: [
              {
                use: "official",
                family: name.lastName,
                given: [
                  name.firstName
                ]
              }
            ],
            telecom: teleCom,
            address: [
              {
                use: "home",
                type: "physical",
                text: address.inputedAddress,
                line: addressLines,
                city: address.city,
                state: address.state,
                district: address.county,
                postalCode: address.zipcode
              }
            ],
            managingOrganization: {
              reference: `Organization/${org}`
            }
          }
      
          return patient
      }

      // Early Head Start-Home Based
      // Family Spirit
      // Healthy Families America
      // Infant Mental Health
      // Maternal Infant Health Program
      // Nurse Family Partnership
      // Play and Learning Strategies-Infant
      // Parents as Teachers
      function getCategoryDetails(cat, key){
        const data = {
          "Early Head Start-Home Based": {
            name:"Early Head Start-Home Based (EHS)",
            overview: "EHS supports you to better understand how your child learns and grows.",
            description: "EHS helps children be healthy. EHS knows parents are their child's first and most important teacher. EHS serves pregnant women, families with children birth to 3 years, and families with a child with a disability.",
            frequency: "Home visits take place weekly for 90 minutes. There are also two social activities that are available to families twice per month.",
            testimonial: "https://youtu.be/sVNc8zBwlyY",
            logo: "logo_ehs"
            
          },
          "Family Spirit": {
            name:"Family Spirit (FS)",
            overview: "FS is the only program for and by American Indian Communities. FS helps you be a strong and healthy parent.",
            description: "FS provides support and education during pregnancy and the first five years of a child's life. Services may include health education, community referrals, breastfeeding support, depression screening, and transportation to medical and other appointments. FS offers home or office visits by a Maternal Child Health Nurse and Outreach Worker.",
            frequency: "Visits range from weekly to monthly depending on the needs of the family and age of the child. Visits generally last between 45-90 minutes.",
            testimonial: "https://www.youtube.com/watch?v=ROBLDv7_LU4",
            logo: "logo_fs"
          },
          "Healthy Families America": {
            name:"Healthy Families America (HFA)",
            overview: "HFA supports you to build a positive bond between you and your children.",
            description: "HFA is a family-centered program, supporting parents during their pregnancy and after to build a positive bond between them and their children. HFA supports child development and growth as well as helping to make connections to healthcare, insurance, and other community resources. With HFA, families will always have support as they navigate the joys and struggles of parenthood, creating a plan with them to meet their needs. Families who are pregnant or with young children, within three months of birth, are eligible.",
            frequency: "Families are offered weekly visits at the beginning of services. Visits are for 60 minutes. How often families have home visits can change depending on their needs.",
            testimonial: "https://www.youtube.com/watch?v=T_sFLuUXmkA",
            logo: "logo_hfa"
          },
          "Infant Mental Health": {
            name:"Infant Mental Health (IMH)",
            overview: "IMH supports you to bond with your baby and overcome challenges in meeting your infant or toddler’s needs.",
            description: "IMH provides support to pregnant people and parents/caregivers who may be having difficulty bonding with their child. IMH enrolls families during pregnancy through their child's third birthday.",
            frequency: "Families generally begin services after their child is born, although services may begin during pregnancy, and continue until their child is age three. The intensity and duration of visits is based on family needs.",
            testimonial: "https://www.youtube.com/watch?v=PYRwBJFw_bQ",
            logo: "logo_imh"
          },
          "Maternal Infant Health Program": {
            name:"Maternal Infant Health Program (MIHP)",
            overview: "MIHP can support you throughout pregnancy and after the delivery of your baby. MIHP can also provide support for an infant and their caregiver.",
            description: "MIHP provides home visits made by a nurse and a social worker, and sometimes by an infant mental health specialist, registered dietician, or lactation consultant. These home visitors may perform health assessments, case management, teaching, and support, as well as connection to community resources. Services provided include prenatal and infant/caregiver assessments, immunization and well-child visit support, health and childbirth education referrals, transportation, and connection with local community resources.",
            frequency: "Visits are offered monthly but may be more frequent. Pregnant persons in the program can receive up to nine visits throughout the pregnancy and after delivery. Depending upon the needs of the infant and their caregiver, infants enrolled in the program can receive up to 36 visits. Home visits may continue until the infant reaches 18 months age based on the needs of the infant and caregiver.",
            testimonial: "https://youtu.be/xtGRArvZVUI",
            logo: "logo_mihp"
          },
          "Nurse Family Partnership": {
            name:"Nurse-Family Partnership (NFP)",
            overview: "NFP can provide you with the help you need during your pregnancy and after your baby arrives.",
            description: "NFP provides personalized home visits by registered nurses. Services provided include prenatal health and childbirth education, infant health, child developmental screenings, practical tips on positive parenting techniques to promote strong parent-child relationships, connection to community services, and encouragement to help families reach their life goals. NFP serves first-time pregnant people who are less than 28 weeks pregnant.",
            frequency: "Families receive weekly, biweekly, or monthly visits dependent on length of enrollment and age of the child. Visit schedule is determined by the family and can be changed based on family needs.",
            testimonial: "https://youtu.be/O56clomqMwE",
            logo: "logo_nfp"
          },
          "Play and Learning Strategies-Infant": {
            name:"Play and Learning Strategies - Infant (PALS-I)",
            overview: "PALS-I supports you in learning ways to help your child learn and grow. PALS helps you have a strong bond with your child.",
            description: "PALS-I provides home visits by a PALS-certified parent coach. PALS-I coaches teach and support early childhood and responsive caregiving strategies to help foster and strengthen positive parent-child interactions. Services provided include parent interaction strength-based assessment, developmental milestone tracking, one-on-one coaching, and connection with local community services.",
            frequency: "Families receive 10-11 visits per year lasting a minimum of 90 minutes.",
            testimonial: "https://youtu.be/m_lckoClKqo",
            logo: "logo_pals"
          },
          "Parents as Teachers": {
            name:"Parents as Teachers (PAT)",
            overview: "Builds parenting confidence",
            description: "PAT provides personalized home visits by certified parent educators trained in child development. PAT supports parents' understanding of what to expect in each stage of their child's development. PAT offers practical tips on ways to encourage learning, manage challenging behavior, and promote strong parent-child relationships. Group meetings are held for parents to gain new insights and to share their experiences, common concerns, and successes. PAT also offers periodic screening of their child's overall development, language, hearing, and vision. PAT serves pregnant women and families with children from birth to kindergarten entry. Families can enroll at any point during this time.",
            frequency: "PAT serves pregnant women and families with children from birth to kindergarten entry. Families can enroll at any point during this time. Program does not have income guidelines.",
            testimonial: "https://youtu.be/IV6fpbsjGOs",
            logo: "logo_pat"
            
          }
        }
        if(cat && key) return data[cat][key]
        return data
      }

      function isLocal() {
        const url = window.location.href
        const localUrl = url.startsWith('file:')
        return localUrl
      }

      function getTask(data) {
        const { patient, purpose, serviceRequestId, organization } = data;
        const taskId = UUID.create().toString();
        const taskObj = {
          resourceType: "Task",
          status: "requested",
          id: taskId,
          businessStatus: {
            coding: [
              {
                system: "https://mi-cie.org/fhir/StructureDefinition",
                code: "NEW",
                display: "new",
              },
            ],
          },
          intent: "order",
          for: {
            reference: `Patient/${patient.id}`,
            type: "Patient",
            display: `${patient.name[0].given[0]} ${patient.name[0].family}`,
          },
          basedOn: [
            {
              reference: `ServiceRequest/${serviceRequestId}`,
              type: "ServiceRequest"
            },
          ],
          authoredOn: new Date().toISOString(),
          description: "Creating task to do an outreach to a patient",
          requester: {
            reference: `Organization/${organization.organization}`,
            display: organization.display,
            type: "Organization",
          },
          owner: {
            reference: `Organization/${organization.organization}`,
            display: organization.display,
            type: "Organization",
          },
          input: [
            {
              type: {
                coding: [
                  {
                    system: "http://mi-cie.org/task-purpose",
                    code: "purpose",
                  },
                ],
              },
              valueString: purpose,
            },
          ],
        };
      
        return taskObj;
      }
  
  module.exports = {
      getObservations,
      getObservation,
      getPatient,
      getCategoryDetails,
      getBundle,
      isLocal, 
      getTask
  }